export const SURAH_NAMES = {
    "001": "Al-Fatihah",
    "002": "Al-Baqarah",
    "003": "Aali-Cimraan",
    "004": "An-Nisaa'",
    "005": "Al-Maa'idah",
    "006": "Al-Ancaam",
    "007": "Al-Acraaf",
    "008": "Al-Anfaal",
    "009": "At-Towbah",
    "010": "Yuunus",
    "011": "Huud",
    "012": "yuusuf",
    "013": "Al-Racd",
    "014": "Ibraahiim",
    "015": "Al-Xijr",
    "016": "Al-Naxl",
    "017": "Al-Israa'",
    "018": "Al-Kahf",
    "019": "Maryam",
    "020": "Dhaahaa",
    "021": "Al-Anbiyaa'",
    "022": "Al-Xajj",
    "023": "Al-Mu'minuun",
    "024": "An-Nuur",
    "025": "Al-Furqaan",
    "026": "Ash-Shucaraa'",
    "027": "Al-Naml",
    "028": "Al-Qasas",
    "029": "Al-Cankabuut",
    "030": "Ar-Ruum",
    "031": "Luqmaan",
    "032": "As-Sajdah",
    "033": "Al-Axzaab",
    "034": "Saba'",
    "035": "Faadhir",
    "036": "Yaasiin",
    "037": "As-Saaffaat",
    "038": "Saad",
    "039": "Al-Zumar",
    "040": "Ghaafir",
    "041": "Fussilat",
    "042": "Ash-Shuuraa",
    "043": "Az-Zukhruf",
    "044": "Ad-Dukhaan",
    "045": "Al-Jaathiyah",
    "046": "Al-Axqaaf",
    "047": "Muxammad",
    "048": "Al-Fatx",
    "049": "Al-Xujjuraat",
    "050": "Qaaf",
    "051": "Ad-Daariyaat",
    "052": "Adh-Dhuur",
    "053": "An-Najm",
    "054": "Al-Qamar",
    "055": "Ar-Raxmaan",
    "056": "Al-Waaqicah",
    "057": "Al-Xadiid",
    "058": "Al-Mujaadalah",
    "059": "Al-Xashr",
    "060": "Al-Mumtaxinah",
    "061": "As-Saff",
    "062": "Al-Jumucah",
    "063": "Al-Munaafiquun",
    "064": "At-Taghaabun",
    "065": "Adh-Dhalaaq",
    "066": "At-Taxriim",
    "067": "Al-Mulk",
    "068": "Al-Qalam",
    "069": "Al-Xaaqqah",
    "070": "Al-Macaarij",
    "071": "Nuux",
    "072": "Al-Jinn",
    "073": "Al-Muzzammil",
    "074": "Al-Muddaththir",
    "075": "Al-Qiyaamah",
    "076": "Al-Insaan",
    "077": "Al-Mursalaat",
    "078": "An-Naba'",
    "079": "An-Naazicaat",
    "080": "Cabasa",
    "081": "At-Takwiir",
    "082": "Al-Infidhaar",
    "083": "Al-Mudhaffifiin",
    "084": "Al-Inshiqaaq",
    "085": "Al-Buruuj",
    "086": "Adh-Dhaariq",
    "087": "Al-Aclaa",
    "088": "Al-Ghaashiyah",
    "089": "Al-Fajr",
    "090": "Al-Balad",
    "091": "Ash-Shams",
    "092": "Al-Layl",
    "093": "Ad-Duxaa",
    "094": "Ash-Sharx",
    "095": "At-Tiin",
    "096": "Al-Calaq",
    "097": "Al-Qadr",
    "098": "Al-Bayyinah",
    "099": "Az-Zalzalah",
    "100": "Al-Caadiyaat",
    "101": "Al-Qaaricah",
    "102": "Al-Takaathur",
    "103": "Al-Casr",
    "104": "Al-Humazah",
    "105": "Al-Fiil",
    "106": "Quraysh",
    "107": "Al-Maacuun",
    "108": "Al-Kawthar",
    "109": "Al-Kaafiruun",
    "110": "An-Nasr",
    "111": "Al-Masad",
    "112": "Al-Ikhlaas",
    "113": "Al-Falaq",
    "114": "An-Naas"
  };
